<template>
    <div class="address-validation-status-bar">
        <label-input
            v-if="feedback"
            label=" "
        >
            <template v-slot:custom>
                <span class="feedback" v-text="feedback" />
            </template>
        </label-input>

        <label-input
            label="Validation status"
            label-style="font-style: italic;"
        >
            <template v-slot:custom>
                <div style="margin: 3px 0 10px 0;">
                    <span class="status-label" :class="{'notice-me': showHighlight}" v-html="statusLabel" />
                    <button
                        @click.prevent="$emit('validate')"
                        v-text="'Validate now'"
                        :disabled="!mayValidate ||person.address_status_id.$model === 2"
                    />
<!--                    <span v-text="ajax.message" />-->
                </div>
            </template>
        </label-input>
    </div>
</template>

<script>
// import axios from 'axios';
// import _pick from 'lodash.pick';

import LabelInput from '../../_components/form/LabelInput';

export default {
    components: {
        LabelInput,
    },

    props: {
        person: {
            type: Object,
        },
        mayValidate: {
            type: Boolean,
        },
    },

    data() {
        return {
            // mayValidate: false,
            // showConfirmation: false,
            // validatedAddress: {},
            // validating: false,
            // overrode: false,
            // feedback: '',
            // ajax: {
            //     message: '',
            // },
            showHighlight: false,
        };
    },

    computed: {
        statusLabel() {
            return [
                '<i class="icon-question" title="Not validated"></i> Not validated yet',
                '<i class="icon-ok" title="Valid"></i> Validated',
                '<i class="icon-alert" title="Failed validation"></i> Validation failed',
                '<i class="icon-student" title="Student override"></i> Student override',
                '<i class="icon-admin" title="Admin override"></i> Admin override',
            ][this.person.address_status_id.$model - 1] ?? '';
        },

        feedback() {
            // TODO
            return '';
        },

        // address() {
        //     return {
        //         address1: this.person.address1.$model,
        //         address2: this.person.address2.$model,
        //         city: this.person.city.$model,
        //         state: this.person.state.$model,
        //         zip: this.person.zip.$model,
        //     };
        // },
    },

    watch: {

    },

    methods: {

    },
}
</script>

<style lang="scss">
.address-validation-status-bar {
    [class^="icon-"] {
        margin-left: 0;
    }

    button {
        margin-left: 2em;
        font-size: 80%;
    }

    .feedback {
        color: #d8842e;
        font-size: 90%;
    }

    .message {
        margin-left: 2em;
        font-size: 80%;
    }

    @import '~animate.css/source/attention_seekers/tada.css';

    .status-label {
        display: inline-block;

        &.notice-me {
            animation-name: tada;
            animation-duration: 1s;
        }
    }
}
</style>
